<template>
  <div>
    <div class="account">
      <div class="msg">
        <i class="circle"></i>
        账实相符率
      </div>
      <div class="plan"></div>
      <div id="echarts30" :style="charts30Style"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    charts30Style: {
      type: Object,
      default: () => {
        return { width: "170px", height: "150px", position: "relative" };
      }
    },
    datagather30: {
      type: Object,
      default: () => {
        return {
          value: "98.6"
        };
      }
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.pies();
  },
  methods: {
    pies() {
      let _this = this;
      //   console.log(_this.id25);
      var behaviorpie = this.$echarts.init(
        document.getElementById("echarts30")
      );
      var placeHolderStyle = {
        normal: {
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          color: "rgba(0,0,0,0)",
          borderWidth: 0
        },
        emphasis: {
          color: "#243255",
          borderWidth: 0
        }
      };

      var dataStyle = {
        normal: {
          formatter: "{c}%",
          position: "center",
          show: true,
          textStyle: {
            fontSize: "24",
            fontWeight: "normal",
            color: "#fff"
          }
        }
      };

      let option = {
        series: [

          {
            type: "pie",
            hoverAnimation: false,
            radius: ["56%", "66%"],
            center: ["46%", "58%"],
            startAngle: 225,
            labelLine: {
              normal: {
                show: false
              }
            },
            label: {
              normal: {
                position: "center"
              }
            },
            data: [
              {
                value: _this.datagather30.value,
                itemStyle: {
                  normal: {
                    color: new _this.$echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: "#02BCA6"
                        },
                        {
                          offset: 1,
                          color: "#01E976"
                        }
                      ]
                    )
                  }
                },
                label: dataStyle
              },
              {
                value: 100 - _this.datagather30.value,
                itemStyle: placeHolderStyle
              }
            ]
          }
        ]
      };
      behaviorpie.setOption(option);
    }
  }
};
</script>
<style scoped>
.account {
  width: 170px;
  height: 150px;
  /* border: 2px solid #264f6d; */
  position: relative;
  background-color: #00665E;
}
.msg {
  width: 100%;
  position: absolute;
  top: 10;
  line-height: 30px;
  left: 20px;
  font-size: 18px;
  color: #42beb6;
  border-radius: 4px;
  font-weight: 550;
}
.circle {
  background-color: #42beb6;
  border-radius: 4px;
  width: 8px;
  display: inline-block;
  height: 8px;
  margin-bottom: 2px;
}
.plan {
  width: 106px;
  height: 106px;
  border: 1px dashed #203d4f;
  border-radius: 54px;
  position: absolute;
  top: 32px;
  left: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts29.vue